import { PATHS } from '@/constants/paths';
import { OfferType, ReferenceLocation } from '@/types';

type SearchCategory = {
  code: string;
  title: string;
};

type SearchEquipment = {
  code: string;
  title: string;
};

export type HousingSearchLinkParams = {
  page?: number;
  offerType?: OfferType;
  categories?: SearchCategory[];
  unitList?: string[];
  equipmentValue?: SearchEquipment[];
  hwbClass?: string[];
  location?: ReferenceLocation;
};

const serializeLocationParam = (location: ReferenceLocation): string =>
  [
    location.type,
    location.code,
    encodeURIComponent(location.name),
    location.latitude ?? '',
    location.longitude ?? '',
  ].join('|');

export const buildHousingSearchHref = ({
  page = 0,
  offerType = OfferType.SELL,
  categories,
  unitList,
  equipmentValue,
  hwbClass,
  location,
}: HousingSearchLinkParams): string => {
  const params = new URLSearchParams();

  params.set('page', String(page));
  params.set('offerType', offerType);

  if (categories?.length) {
    params.set('categories', [...new Set(categories.map((category) => category.code))].join(','));
  }

  if (unitList?.length) {
    params.set('unitList', unitList.join(','));
  }

  if (equipmentValue?.length) {
    params.set('equipmentValue', [...new Set(equipmentValue.map((item) => item.code))].join(','));
  }

  if (hwbClass?.length) {
    params.set('hwbClass', hwbClass.join(','));
  }

  if (location) {
    params.set('location', serializeLocationParam(location));
  }

  return `/${PATHS.HOUSING}?${params.toString()}`;
};

export const buildRegionUnitList = (federalStateCode: string): string[] => ['AT', federalStateCode];

export const FEDERAL_STATE_UNIT_CODE = {
  burgenland: 'AT.1',
  kaernten: 'AT.2',
  niederoesterreich: 'AT.3',
  oberoesterreich: 'AT.4',
  salzburg: 'AT.5',
  steiermark: 'AT.6',
  tirol: 'AT.7',
  vorarlberg: 'AT.8',
  wien: 'AT.9',
} as const;
